<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Отчет по сотрудникам</h1>
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row">
        <h3 class="subtitle">Включить в отчет:</h3>
      </div>
      <div class="page__row mb-40">
        <AppTableControls :table-list="tableList"/>
      </div>
      <div class="page__row mb-20"></div>
    </section>

    <section class="section page__footer">
      <div class="page__buttons">
        <div class="page__item">
          <AppButton title="Создать" type="main" @click.native="createReport"/>
        </div>
      </div>
    </section>

    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import ThePagePreloader from '../../components/page/ThePagePreloader'
import AppButton from '@/components/page/button/AppButton'
import AppTableControls from '@/components/page/table/AppTableControls'

export default {
  name: 'UsersReport',
  components: {
    AppTableControls,
    AppButton,
    ThePagePreloader
  },
  data () {
    return {}
  },
  computed: {
    isLoading () {
      return this.$store.getters.usersReportIsLoading
    },
    tableList () {
      return this.$store.getters.usersReportTableList
    },

    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    createReport () {
      // сформировать отчет
    }
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
.user-list {
  &__search {
    width: 400px;
  }

  &__footer {
    padding-bottom: 110px;
  }
}

.no-records {
  width: 100%;
  margin-top: 80px;
}
</style>
